export function reportCaption(reportCode?: string): string {
  return reportCode ? `کد گزارش: ${reportCode?.split("-")[1]}` : "";
}
